import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CAR_DELIVERIES,
  GET_CAR_DELIVERY_DETAILS,
  CREATE_CAR_DELIVERY,
  UPDATE_CAR_DELIVERY,
  DELETE_CAR_DELIVERY,
} from "./actionTypes"
import {
  getCarDeliveriesFail,
  getCarDeliveriesSuccess,
  getCarDeliveryDetailsSuccess,
  getCarDeliveryDetailsFail,
  createCarDeliveryFail,
  createCarDeliverySuccess,
  updateCarDeliverySuccess,
  updateCarDeliveryFail,
  deleteCarDeliverySuccess,
  deleteCarDeliveryFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// Car Delivery - This line cannot be edited or removed
function getCarDeliveriesAPi({ page, sort, limit, searchText }) {
  return get(
    `/delivery/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText}`
  )
}

const getCarDeliveryDetailsAPi = carDeliveryId => {
  return get(`/delivery/admin/${carDeliveryId}`)
}

const createCarDeliveryApi = ({ carDelivery, onCloseClick }) => {
  return post("/delivery/admin/new", carDelivery, onCloseClick)
}

const updateCarDeliveryApi = ({ carDelivery, carDeliveryId, onCloseClick }) => {
  return ApiPut(`/delivery/admin/${carDeliveryId}`, carDelivery, onCloseClick)
}

const deleteCarDeliveryApi = ({ carDeliveryId }) => {
  return del(`/delivery/admin/${carDeliveryId}`)
}

function* fetchCarDeliveries({ payload }) {

  try {
    const response = yield call(getCarDeliveriesAPi, payload)
    yield put(getCarDeliveriesSuccess(response))
  } catch (error) {
    yield put(getCarDeliveriesFail(error))
  }
}

function* fetchCarDeliveryDetails({ payload: carDeliveryId }) {
  try {
    const response = yield call(getCarDeliveryDetailsAPi, carDeliveryId)
    yield put(getCarDeliveryDetailsSuccess(response))
  } catch (error) {
    yield put(getCarDeliveryDetailsFail(error))
  }
}

function* onCreateCarDelivery({ payload }) {
  try {
    const response = yield call(createCarDeliveryApi, payload)

    yield put(createCarDeliverySuccess(response))
    if (payload?.onCloseClick) {
      payload.onCloseClick()
    }
    doneNotification("Ca rDelivery Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createCarDeliveryFail(error))
  }
}

function* onUpdateCarDelivery({ payload }) {
  try {
    const response = yield call(updateCarDeliveryApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Car Delivery Updated Successfully!",
        title: "",
      })
      yield put(updateCarDeliverySuccess(response))
      if (payload?.onCloseClick) {
        payload.onCloseClick()
      }
      if (payload.history) {
        payload.history.push("/car-delivery/all")
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateCarDeliveryFail(error.response.data))
  }
}

function* onDeleteCarDelivery({ payload }) {
  try {
    const response = yield call(deleteCarDeliveryApi, payload)
    yield put(deleteCarDeliverySuccess(response))
    doneNotification("Car Delivery Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteCarDeliveryFail(error?.response?.data))
  }
}

function* carDeliverySaga() {
  yield takeEvery(GET_CAR_DELIVERIES, fetchCarDeliveries)
  yield takeEvery(GET_CAR_DELIVERY_DETAILS, fetchCarDeliveryDetails)
  yield takeEvery(CREATE_CAR_DELIVERY, onCreateCarDelivery)
  yield takeEvery(UPDATE_CAR_DELIVERY, onUpdateCarDelivery)
  yield takeEvery(DELETE_CAR_DELIVERY, onDeleteCarDelivery)
}

export default carDeliverySaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
